import { useEffect, useState, useRef } from 'react'

const sortObjectKeys = obj =>
  Object.entries(obj)
    .sort()
    .reduce((o, [k, v]) => ((o[k] = v), o), {})

export const isEqual = (val1, val2) => {
  if (typeof val1 === 'number' && typeof val2 === 'number') return val1 === val2
  if (typeof val1 === 'string' && typeof val2 === 'string') return val1 === val2
  if (Array.isArray(val1) && Array.isArray(val2)) {
    return JSON.stringify(val1) === JSON.stringify(val2)
  }
  if (typeof val1 === 'object' && typeof val2 === 'object') {
    return JSON.stringify(sortObjectKeys(val1)) === JSON.stringify(sortObjectKeys(val2))
  }
  return false
}

export const useEffectOnce = effect => {
  const effectFn = useRef(effect)
  const destroyFn = useRef()
  const effectCalled = useRef(false)
  const rendered = useRef(false)
  const [, setVal] = useState(0)

  if (effectCalled.current) {
    rendered.current = true
  }

  useEffect(() => {
    // only execute the effect first time around
    if (!effectCalled.current) {
      destroyFn.current = effectFn.current()
      effectCalled.current = true
    }

    // this forces one render after the effect is run
    setVal(val => val + 1)

    return () => {
      // if the comp didn't render since the useEffect was called,
      // we know it's the dummy React cycle
      if (!rendered.current) {
        return
      }

      // otherwise this is not a dummy destroy, so call the destroy func
      if (destroyFn.current) {
        destroyFn.current()
      }
    }
  }, [])
}
